import React from 'react';
import Otto from './Otto';

// Otto in the genuine "human moments" of a page's empty states. Both are
// presentational only — the page supplies the directive copy + actions
// around them. Shared dressed Otto symbols (build #7); admin/internal only.

// Confused Otto — Everyday Otto tilting his head with a teal "?", for
// "your search + filters matched nothing" moments. The head-tilt is a
// static transform (no motion), so it's reduced-motion-safe by default.
export function OttoConfused({ size = 96 }) {
  return (
    <span className="relative inline-block leading-none">
      <span className="inline-block" style={{ transform: 'rotate(-7deg)', transformOrigin: 'bottom center' }}>
        <Otto pose="searching" size={size} ariaLabel="Otto can't find a match" />
      </span>
      <span
        aria-hidden="true"
        className="absolute font-['Metropolis'] font-extrabold"
        style={{ top: -2, right: -4, color: '#2E8FA1', fontSize: Math.round(size * 0.34), lineHeight: 1 }}>
        ?
      </span>
    </span>
  );
}

// Sleeping Otto — cap off, goggles on the brow, a soft "Zzz". For the
// empty "Closed" board column (nothing has wrapped yet).
export function OttoSleeping({ size = 96 }) {
  return <Otto pose="sleeping" size={size} ariaLabel="Otto is napping" />;
}
